import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { fetchWithRetry } from "../utils/ApiHelper";

const SearchBar = () => {
  const navigate = useNavigate();
  const [searchType, setSearchType] = useState("grandprix");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("Fetching data...");

        let grandPrixList = JSON.parse(localStorage.getItem("apiGrandPrixListV2")) || [];
        if (grandPrixList.length === 0) {
          const gpResponse = await fetchWithRetry(
            `${process.env.REACT_APP_STATS_BACKEND_ADDRESS || "/api/stats"}/grand_prix`,
            {
              headers: { accepts: "application/json" },
              method: "GET",
            }
          );
          grandPrixList = await gpResponse.json();
          localStorage.setItem("apiGrandPrixListV2", JSON.stringify(grandPrixList));
        }

        let playerList = JSON.parse(localStorage.getItem("apiRosterV2")) || [];
        if (playerList.length === 0) {
          const rosterResponse = await fetchWithRetry(
            `${process.env.REACT_APP_STATS_BACKEND_ADDRESS || "/api/stats"}/player_roster/extended`,
            {
              headers: { accepts: "application/json" },
              method: "GET",
            }
          );
          playerList = await rosterResponse.json();
          localStorage.setItem("apiRosterV2", JSON.stringify(playerList));
        }

        console.log("Data fetched successfully");
        setOptions(searchType === "grandprix" ? grandPrixList : playerList);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [searchType]);

  const handleSearchTypeChange = (event) => {
    const selectedType = event.target.value;
    setSearchType(selectedType);
    setOptions(selectedType === "grandprix"
      ? JSON.parse(localStorage.getItem("apiGrandPrixListV2")) || []
      : JSON.parse(localStorage.getItem("apiRosterV2")) || []
    );
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    navigate(`/stats/${searchType}/${event.target.value}`);
  };

  return (
    <Box>
      <Box>
        <Typography variant="h8" sx={{ fontFamily: '"Press Start 2P", sans-serif', fontWeight: 'bold', fontSize: '.75rem', width: "400px", maxWidth: "90vw" }}>
          Stats Search
        </Typography>
      </Box>
      <Box
        display="flex"
        sx={{
          maxWidth: "90vw",
          width: "400px",
          margin: "0 auto", // Center horizontally
          borderRadius: 2,
          border: 3,
          gap: 2, // Add space between dropdowns,
          backgroundColor: 'black',
          color: 'black',
          mb: 1
        }}
      >
        {/* Search Type Dropdown */}
        <select
          value={searchType}
          onChange={handleSearchTypeChange}
          className="dropdown search-type"
          style={{
            flex: '2',
            padding: "8px",
            borderRadius: "4px",
            border: "0px solid #ccc",
            fontSize: "16px",
            maxWidth: "40vw",
            width: "178px",
            backgroundColor: '#4A4A4A',
            color: 'white',
          }}
        >
          <option value="grandprix">Grand Prix</option>
          <option value="players">Players</option>
        </select>

        {/* Options Dropdown */}
        <select
          value={selectedOption}
          onChange={handleOptionChange}
          className="dropdown options"
          style={{
            flex: '3',
            padding: "8px",
            borderRadius: "4px",
            border: "0px solid #ccc",
            fontSize: "16px",
            maxWidth: "50vw",
            width: "222px",
            backgroundColor: '#4A4A4A',
            color: 'white',
          }}
        >
          <option value="" disabled>
            Search...
          </option>
          {options.map((entry) => (
            <option key={entry.grandPrixId || entry.playerId} value={entry.grandPrixId || entry.playerId}>
              {(entry.title ? `${entry.title} | ${entry.createDate}` : `${entry.firstName} ${entry.lastName}`)}
            </option>
          ))}
        </select>
      </Box>
    </Box>
  );
};

export default SearchBar;
